import { AdDataAnalysisDashboard } from '../AdDataAnalysisDashboard';

export const SelfAnalysisTab = () => {
  return <AdDataAnalysisDashboard />;
};
